<template>
    <section ref="main" class="container cookie-info-settings container--calcPadding margin-both-xl" >

    </section>
</template>


<script>
export default {
    props : ['data'],
    data(){
        return{
            options: ''
        }
    },
    mounted(){
        const cokieEl = document.getElementById("cicc-template");
        if(cokieEl && this.$refs.main){
            this.options = cokieEl.cloneNode( true )
            this.$refs.main.appendChild(this.options)
            window.$(document).find('.cookie-info-settings #cicc-template .coi-category-consent__update-consent').on('click', function(){
                window.location.reload(true);
            })
        }
      //this.options = document.getElementById("cicc-template").cloneNode( true );   
    }
}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.module-tester{
    
}
</style>